import { URL_CONSTANTS } from "../_constants";
import { ServiceHelper } from "./ServiceHelper";

export const AvaibookService = {
    listAccommodations,
}

function listAccommodations(integrationUID: string) {
    return ServiceHelper.getRequest(
        URL_CONSTANTS.INTEGRATION_AVAIBOOK_ACCOMMODATIONS,
        {
            uid: integrationUID
        }
    );
}